// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"us-z","giftOrPromoSelector":"vs-z","disabled":"ws-z","subTitle":"xs-z","selectShipAddressMessage":"ys-z","changePayment":"zs-z"};